<template>
    <list-page
        page-title="Vendors"
        page-icon="mdi-account-multiple-outline"
        collection-name="vendor"
        :items-per-page="20"
        add-dialog-title="Add Vendor"
        is-filter
    />
</template>

<script>
import ListPage from '../../../components/pages/List';


export default {
    name: 'VendorList',
    components: { ListPage },

};
</script>

<style scoped></style>
